import React, { Component } from 'react'

class PermissionDataForm extends Component {
  constructor (props) {
    super(props)

    // state
    this.state = { permission: {} }

    this.handleChange = this.handleChange.bind(this)
  }

  UNSAFE_componentWillReceiveProps (nextProps, nextContext) {
    this.setState({
      permission: nextProps.permission
    })
  }

  handleChange (event) {
    this.props.onChange(event.target.name, event.target.value)
  }

  render () {
    return (
            <>

                <div className="form-group">
                    <div className="col-sm-8 col-sm-offset-2">
                        <div className="form-material">
                            <input className="form-control"
                                   type="text"
                                   id="input-name"
                                   placeholder="Please enter a name"
                                   name="name"
                                   value={this.state.permission.name}
                                   onChange={this.handleChange}
                            />
                            <label htmlFor="input-name">Permission Name</label>
                        </div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="col-sm-8 col-sm-offset-2">
                        <div className="form-material">
                            <input className="form-control"
                                   type="text"
                                   id="input-codename"
                                   placeholder="Please enter a codename"
                                   name="codename"
                                   value={this.state.permission.codename}
                                   onChange={this.handleChange}
                            />
                            <label htmlFor="input-codename">Codename</label>
                        </div>
                    </div>
                </div>
            </>
    )
  }
}

// Set default props
PermissionDataForm.defaultProps = {
  permission: {},
  onChange: () => {
  }
}

export {
  PermissionDataForm
}
